/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GetSafetyConsultantDefectResponse } from '../models/get-safety-consultant-defect-response';
import { CreateSafetyConsultantDefectRequest } from '../models/create-safety-consultant-defect-request';
import { UpdateSafetyConsultantDefectRequest } from '../models/update-safety-consultant-defect-request';
@Injectable({
  providedIn: 'root',
})
class SafetyConsultantDefectService extends __BaseService {
  static readonly SafetyConsultantDefectGetAllPath = '/SafetyConsultantDefect/GetAll';
  static readonly SafetyConsultantDefectGetByIdPath = '/SafetyConsultantDefect/GetById';
  static readonly SafetyConsultantDefectCreatePath = '/SafetyConsultantDefect/Create';
  static readonly SafetyConsultantDefectCreateRangePath = '/SafetyConsultantDefect/CreateRange';
  static readonly SafetyConsultantDefectUpdatePath = '/SafetyConsultantDefect/Update';
  static readonly SafetyConsultantDefectDeletePath = '/SafetyConsultantDefect/Delete';
  static readonly SafetyConsultantDefectDeleteRangePath = '/SafetyConsultantDefect/DeleteRange';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  SafetyConsultantDefectGetAllResponse(): __Observable<__StrictHttpResponse<Array<GetSafetyConsultantDefectResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/SafetyConsultantDefect/GetAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetSafetyConsultantDefectResponse>>;
      })
    );
  }  SafetyConsultantDefectGetAll(): __Observable<Array<GetSafetyConsultantDefectResponse>> {
    return this.SafetyConsultantDefectGetAllResponse().pipe(
      __map(_r => _r.body as Array<GetSafetyConsultantDefectResponse>)
    );
  }

  /**
   * @param Id undefined
   */
  SafetyConsultantDefectGetByIdResponse(Id?: string): __Observable<__StrictHttpResponse<GetSafetyConsultantDefectResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Id != null) __params = __params.set('Id', Id.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/SafetyConsultantDefect/GetById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetSafetyConsultantDefectResponse>;
      })
    );
  }
  /**
   * @param Id undefined
   */
  SafetyConsultantDefectGetById(Id?: string): __Observable<GetSafetyConsultantDefectResponse> {
    return this.SafetyConsultantDefectGetByIdResponse(Id).pipe(
      __map(_r => _r.body as GetSafetyConsultantDefectResponse)
    );
  }

  /**
   * @param request undefined
   */
  SafetyConsultantDefectCreateResponse(request: CreateSafetyConsultantDefectRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/SafetyConsultantDefect/Create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  SafetyConsultantDefectCreate(request: CreateSafetyConsultantDefectRequest): __Observable<Blob> {
    return this.SafetyConsultantDefectCreateResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param request undefined
   */
  SafetyConsultantDefectCreateRangeResponse(request: Array<CreateSafetyConsultantDefectRequest>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/SafetyConsultantDefect/CreateRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  SafetyConsultantDefectCreateRange(request: Array<CreateSafetyConsultantDefectRequest>): __Observable<Blob> {
    return this.SafetyConsultantDefectCreateRangeResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param request undefined
   */
  SafetyConsultantDefectUpdateResponse(request: UpdateSafetyConsultantDefectRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/SafetyConsultantDefect/Update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  SafetyConsultantDefectUpdate(request: UpdateSafetyConsultantDefectRequest): __Observable<Blob> {
    return this.SafetyConsultantDefectUpdateResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param id undefined
   */
  SafetyConsultantDefectDeleteResponse(id?: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/SafetyConsultantDefect/Delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  SafetyConsultantDefectDelete(id?: string): __Observable<Blob> {
    return this.SafetyConsultantDefectDeleteResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param ids undefined
   */
  SafetyConsultantDefectDeleteRangeResponse(ids: Array<string>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = ids;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/SafetyConsultantDefect/DeleteRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param ids undefined
   */
  SafetyConsultantDefectDeleteRange(ids: Array<string>): __Observable<Blob> {
    return this.SafetyConsultantDefectDeleteRangeResponse(ids).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module SafetyConsultantDefectService {
}

export { SafetyConsultantDefectService }
